<template>
    <div class="demographic">
        <select class="dropdown" v-if="boundaryNames" v-model="selectedDemographic">
            <option disabled value="">Choose Demographic Indicator</option>
            <option
                    :disabled="avgTravel"
                    v-for="column in demographicColumns"
                    v-bind:key="column.value"
                    v-bind:value="column.value">{{column.name}}
            </option>
        </select>
        <span class="label"> {{demographicName}}</span>
    </div>
</template>

<script>
    export default {
        name: "demographicSelect",
        props: ['demographicColumns','demographicColumn', 'boundaryNames', 'avgTravel'],
        data: function () {
            return {
                selectedDemographic: this.demographicColumn,
            }
        },
        computed: {
            demographicName: function () {
                for (let v of this.demographicColumns) {
                    if (v.value === this.demographicColumn) {
                        return v.name;
                    }
                }
                return ''
            }
        },
        watch: {
            demographicColumn: function () {
                this.selectedDemographic = this.demographicColumn
            },
            selectedDemographic: function () {
                this.$emit('demographicInput', this.selectedDemographic)
            },
        }
    }
</script>

<style scoped>
    select {
        border-color: #f3f3f3;
    }

    select:focus {
        outline: 0;
        border-color: black;
    }

    select {
        border-radius: 10px;
        min-width: 0;
    }

    select option {
        font-size: 1rem;
    }

    .label {
        display: none;
    }

    @media print {
        .label {
            display: table;
        }

        .dropdown {
            display: none;
        }
    }
</style>